import periodListComponent from './periodList.component';
import periodCard from './periodCard/periodCard';

let periodListModule = angular.module('periodList', [
  periodCard
])

.component('periodList', periodListComponent)

.name;

export default periodListModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/periodList/periodList.js